import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Drawer, Box, Divider} from 'views/components';

import NavbarLogo from './navbar_top/NavbarLogo';
import NavbarServices from './navbar_services/NavbarServices';
import NavbarUser from './navbar_bottom/NavbarUser';


const NavBar = (props) => {
  const services = props.services;

  return (
    <Drawer
      sx={{
        'width': 240,
        'flexShrink': 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
        },
      }}
      PaperProps={{
        sx: {
          backgroundColor: 'navbar.main',
        },
      }}
      open={true}
      variant="permanent"
      anchor="left"
    >
      <Box sx={{
        my: 5,
        ml: 3,

        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}>
        <NavbarLogo />
      </Box>
      <Divider sx={{borderColor: 'white'}}/>
      <Box sx={{
        mt: 'auto',
        mb: 'auto',
      }}>
        <NavbarServices
          services={Object.values(services)}
        />
      </Box>
      <Divider sx={{borderColor: 'white'}}/>
      <Box sx={{
        my: 8,
        ml: 3,
      }}>
        <NavbarUser />
      </Box>
    </Drawer>
  );
};

NavBar.propTypes = {
  services: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
